import React from 'react';

import { AppStoreBadge } from '@reverbdotcom/commons/src/components/app_store_badge';

interface IProps {
  userLocale: string;
  linkLocation: 'footer' | 'homepage' | 'sale-ended';
}

const links = {
  homepage: {
    ios: 'https://reverb.app.link/homepageios',
    android: 'https://reverb.app.link/homepageandroid',
  },
  footer: {
    ios: 'https://reverb.app.link/sitefooterios',
    android: 'https://reverb.app.link/sitefooterandroid',
  },
};

export function AppleAppStoreLink(props: IProps) {
  const link = links[props.linkLocation]?.ios;

  return (
    <a
      className="d-inline-block"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <AppStoreBadge brand="apple" locale={props.userLocale.slice(0, 2) || 'en'} />
    </a>
  );
}

export function GooglePlayStoreLink(props: IProps) {
  const link = links[props.linkLocation]?.android;

  return (
    <a
      className="d-inline-block"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <AppStoreBadge brand="google" locale={props.userLocale.slice(0, 2) || 'en'} />
    </a>
  );
}
